/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Table, Button } from 'antd'
import ModalDetail from './modalDetail'
import { changeStringTime, copyToClip } from '../../../util'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
  }

  //导出报表
  clickDownload = (columns, list) => {
    let str = [],
      title = []
    columns.map((item) => {
      title.push(item.title)
    })
    str.push(title.join(','))
    for (let i = 0; i < list.length; i++) {
      let temp = []
      for (let j = 0; j < columns.length; j++) {
        //在订单号和流水号前面加入~符号,防止导出时错乱
        if (
          columns[j].dataIndex === 'temporary_number' ||
          columns[j].dataIndex === 'serial_number'
        ) {
          temp.push(
            '~' +
              list[i][columns[j].dataIndex]
                .replace(/,/g, '+')
                .replace(/，/g, '+')
          )
        } else {
          temp.push(
            list[i][columns[j].dataIndex].replace(/,/g, '+').replace(/，/g, '+')
          )
        }
        //temp.push(list[i][columns[j].dataIndex])
      }
      str.push(temp.join(','))
    }
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
  }

  onShowModal = (record) => {
    this.setState({ visible: true })
    this.props.fetchRecordDetails(record.serial_number) //详情
  }

  handleOk = () => {
    this.setState({ visible: false })
  }
  handleCancel = () => {
    this.setState({ visible: false })
  }

  //求和(金额)
  priceSum = (list, record_type) => {
    let sum = 0
    list.map((item) => {
      // if(record_type === '1'){
      //     sum += +item.price;
      // }else{
      //     sum += +item.amounts;
      // }
      sum += +item.price
    })
    return sum.toFixed(2) || 0
  }

  render() {
    const { list, record_type, recordDetail, period } = this.props
    let columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '会员名',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '订单号',
        dataIndex: 'temporary_number',
        key: 'temporary_number',
      },
      {
        title: '流水号',
        dataIndex: 'serial_number',
        key: 'serial_number',
      },
      {
        title: '记录',
        dataIndex: 'search_type',
        key: 'search_type',
      },
      {
        title: '支付方式',
        dataIndex: 'payment_name',
        key: 'payment_name',
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '支付时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
    ]
    let goods_col = {
      title: '商品',
      dataIndex: 'commodity',
      key: 'commodity',
    }
    if (+record_type != 2 && +record_type != 3) {
      columns.splice(5, 0, goods_col)
    }

    const data = list.map((item) => {
      if (record_type === '1') {
        return item
      } else {
        item.amounts = item.amount / 100
        return item
      }
    })

    let reportName = sessionStorage.getItem('reportName')
    if (period && period.start_time && period.end_time) {
      reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
    }

    const sum = this.priceSum(data, record_type)
    return (
      <div style={{ marginTop: '1rem' }}>
        <div
          style={{
            cursor: 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <Button>
            <a
              id="test"
              href={this.clickDownload(columns || [], list)}
              download={`${reportName}.csv`}
            >
              导出
            </a>
          </Button>
          <Button type="primary" ghost onClick={() => copyToClip(sum)}>
            合计:￥{sum}元
          </Button>
        </div>
        <h3>营业记录</h3>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={data}
          size="middle"
        />

        <ModalDetail
          {...this.state}
          list={recordDetail}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Consume/component/report.js